import { useState } from "react";

const apiBaseUrl = process.env.REACT_APP_API_URL;
const frontendUrl = process.env.REACT_APP_FRONTEND_URL || window.location.origin;

const PublicJoinLinkCard = ({ group, onChanged }) => {
  const [saving, setSaving] = useState(false);
  const joinUrl = group.publicJoinCode
    ? `${frontendUrl}/join-group/${group.publicJoinCode}`
    : "";

  const runAction = async (action) => {
    if (
      action === "regenerate" &&
      !window.confirm("Regenerate this link? The old public link will stop working.")
    ) {
      return;
    }
    setSaving(true);
    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(
        `${apiBaseUrl}/api/participant-groups/${group.id}/join-link`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ action }),
        },
      );
      const body = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(body.message || "Could not update link.");
      onChanged?.();
    } catch (error) {
      alert(error.message || "Could not update link.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="rounded-xl border border-gray-100 bg-white p-5 shadow-lg">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <p className="text-xs font-bold uppercase tracking-wide text-[#004a7e]">
            Public join link
          </p>
          <h3 className="text-lg font-black text-gray-900">Request to join</h3>
          <p className="mt-1 text-sm text-gray-500">
            People can request to join as participants only. Admin approval is required.
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            className="rounded-lg bg-[#004a7e] px-3 py-2 text-sm font-bold text-white disabled:opacity-50"
            disabled={saving || group.publicJoinEnabled}
            onClick={() => runAction("enable")}
          >
            Enable
          </button>
          <button
            className="rounded-lg border border-gray-300 px-3 py-2 text-sm font-bold text-gray-700 disabled:opacity-50"
            disabled={saving || !group.publicJoinEnabled}
            onClick={() => runAction("disable")}
          >
            Disable
          </button>
          <button
            className="rounded-lg border border-orange-300 px-3 py-2 text-sm font-bold text-orange-700 disabled:opacity-50"
            disabled={saving}
            onClick={() => runAction("regenerate")}
          >
            Regenerate
          </button>
        </div>
      </div>
      <div className="mt-4 rounded-lg bg-gray-50 p-3">
        {group.publicJoinEnabled ? (
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
            <input className="input input-bordered flex-1" readOnly value={joinUrl} />
            <button
              className="rounded-lg bg-white px-3 py-2 text-sm font-bold text-[#004a7e] ring-1 ring-[#004a7e]"
              onClick={() => navigator.clipboard?.writeText(joinUrl)}
            >
              Copy
            </button>
          </div>
        ) : (
          <p className="text-sm font-semibold text-gray-500">
            Public join link is currently off.
          </p>
        )}
      </div>
    </div>
  );
};

export default PublicJoinLinkCard;